import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
import { leadMagnetPagesStatus } from 'reduxModules/leadMagnetPages'
import { leadMagnetPageStateSelector as stateSelector } from 'reduxModules/leadMagnetPages/selectors'
import { leadMagnetPageDispatchers as dispatchers } from 'reduxModules/leadMagnetPages/dispatchers'
import { TutorialSummaryPropTypes } from 'components/generic/CourseSummary/propTypes'

import withRouterV6 from '../../utils/withRouterV6'
import Video from '../generic/CourseSummary'
import BannerSlide from '../generic/BannerSlideShow/BannerSlide'
import VideoModal from '../generic/VideoModal'
import LeadMagnetFunnelForm from '../Tutorials/TutorialDetail/LeadMagnetFunnelForm'

import './styles.css'

export class LeadMagnetPage extends Component {
  componentDidMount() {
    this.props.loadLeadMagnetPage()
  }

  render() {
    if (this.props.status !== leadMagnetPagesStatus.success) return null

    const { banner, videos, player } = this.props
    const metaTitle = this.props.title || this.props.subtitle
    const metaDescription = this.props.subtitle

    return (
      <div id="LeadMagnetPage">
        <Helmet>
          <title>{metaTitle} | Stan Winston School of Character Arts</title>
          <meta name="description" content={metaDescription} />
          <meta property="og:title" content={this.props.fbTitle || metaTitle} />
          <meta
            property="og:description"
            content={this.props.fbDescription || metaDescription}
          />
          <meta content="article" property="og:type" />
        </Helmet>
        <BannerSlide
          {...banner}
          video={banner.video}
          displayVideo={() => this.toggleVideo(banner.video)}
        />
        <section className="page-title wrapper heading">
          <h1>{this.props.title}</h1>
        </section>
        <section id="videos" className="wrapper">
          {videos.map((video) => (
            <Video
              key={`video-${video.slug}`}
              className="video"
              slug={video.slug}
              teacher={video.artist.title}
              teacherSlug={video.artist.slug}
              title={video.title}
              thumb={video.firstFrameImage.default}
              isQuickPlay
              onQuickPlayClick={() =>
                this.props.loadLeadMagnetPageVideo({
                  urlHi: video.videoHi,
                  urlLow: video.videoLow,
                  vtt: video.vttFile,
                  subtitles: video.subtitles
                })
              }
            />
          ))}
        </section>
        {player.isPlaying && (
          <VideoModal
            close={() => this.props.clearLeadMagnetPageVideo()}
            urlHi={player.urlHi}
            urlLow={player.urlLow}
            subtitles={player.subtitles}
            vtt={player.vtt}
            visible={player.isPlaying}
          />
        )}
        <LeadMagnetFunnelForm tag={this.props.tag} />
      </div>
    )
  }
}

LeadMagnetPage.propTypes = {
  loadLeadMagnetPage: PropTypes.func.isRequired,
  status: PropTypes.string,
  subtitle: PropTypes.string,
  banner: PropTypes.shape({
    asset: PropTypes.shape({
      original: PropTypes.string,
      default: PropTypes.string,
      mobile: PropTypes.string,
      mobilexs: PropTypes.string,
      normal: PropTypes.string
    }),
    countdownDate: PropTypes.string,
    ctaLabel: PropTypes.string,
    ctaUrl: PropTypes.string,
    description: PropTypes.string,
    id: PropTypes.number,
    link: PropTypes.string,
    orderDate: PropTypes.string,
    title: PropTypes.string,
    hasGradient: PropTypes.bool
  }).isRequired,
  slug: PropTypes.string,
  body: PropTypes.string,
  tutorials: PropTypes.arrayOf(PropTypes.shape(TutorialSummaryPropTypes))
    .isRequired,
  isMobile: PropTypes.bool,
  tag: PropTypes.string
}

LeadMagnetPage.defaultProps = {
  body: '',
  banner: {
    medium: ''
  },
  tutorials: [],
  slug: '',
  subtitle: '',
  isMobile: false,
  tag: 'Lead Magnet Email Lead'
}

export default withRouterV6(connect(stateSelector, dispatchers)(LeadMagnetPage))
